export const VIEW = "VIEW";
export const ADVANCE_SEARCH = "ADVANCE_SEARCH";
export const DELETE = "DELETE";
export const APPROVE_USERS = "APPROVE_USERS";
export const MANAGE_CATALOG = "MANAGE_CATALOG";
export const VIEW_LOAN_LIBRARY = "VIEW_LOAN_LIBRARY";
export const MANAGE_LOAN_LIBRARY_CATALOG = "MANAGE_LOAN_LIBRARY_CATALOG";
export const MANAGE_LOAN_LIBRARY_LOANS = "MANAGE_LOAN_LIBRARY_LOANS";
export const MANAGE_OWN_CATALOG_ITEMS = "MANAGE_OWN_CATALOG_ITEMS";
export const MANAGE_OWN_LOANS = "MANAGE_OWN_LOANS";

